module.exports = __webpack_public_path__ + "img/1080_22.0f8eac79.jpg";